import axios from 'axios';
import ShortUniqueId from 'short-unique-id';
import { api } from 'boot/axios';

// eslint-disable-next-line import/prefer-default-export
export default class CustomButtonActions {
    constructor (app) {
        this.app = app;
    }

    // eslint-disable-next-line class-methods-use-this
    createCertCommon (params) {
        const { user } = this.app.$store.state.pages;
        this.app.$db.users.getUserCertificate(user.id, params.id).then((row) => {
            let filename;
            if (!row) {
                const uuid = new ShortUniqueId({ length: 8 })();
                filename = `${uuid}.pdf`;
            } else {
                const { url } = row;
                filename = url.substring(url.lastIndexOf('/') + 1);
            }
            if (params.image_url.includes('http://')) {
                params.image_url = params.image_url.replace('http://', 'https://');
            }

            const data = new FormData();
            data.append('user_id', user.id);
            data.append('key', '70fa-e5C2');
            data.append('filename', filename);
            data.append('cert_count', params.cert_count);
            data.append('cert_date', params.cert_date);
            data.append('cert_organizer', params.cert_organizer);
            data.append('image_url', params.image_url);
            axios.post(`${api.defaults.baseURL}/generate_cert_common.php`, data).then((r) => {
                this.loading = false;
                if (r && r.data && r.data.pdf_url) {
                    window.open(r.data.pdf_url, '_blank');
                    if (!row) {
                        this.app.$db.users.saveUserCertificate({
                            user_id: user.id,
                            button_id: params.id,
                            url: r.data.pdf_url,
                        });
                    }
                } else {
                    console.error(r);
                    this.app.$q.notify('Ошибка создания сертификата');
                }
            });
        });
    }

    createCert1 () {
        const { user } = this.app.$store.state.pages;
        axios.get(`https://sot.club/api/generate_cert.php?id=${user.id}&key=70fa-e5C2`).then((r) => {
            this.loading = false;
            if (r && r.data && r.data.pdf_url) {
                // queryBot(`insert into user_certificates (user_id, url) values ('${this.user.id}', '${r.data.pdf_url}')`);
                window.open(r.data.pdf_url, '_blank');
            } else {
                this.app.$q.notify('Ошибка создания сертификата');
            }
        });
    }

    createCert3 () {
        const { user } = this.app.$store.state.pages;
        axios.get(`https://sot.club/api/generate_cert3.php?id=${user.id}&key=70fa-e5C2`).then((r) => {
            this.loading = false;
            if (r && r.data && r.data.pdf_url) {
                // queryBot(`insert into user_certificates (user_id, url) values ('${this.user.id}', '${r.data.pdf_url}')`);
                window.open(r.data.pdf_url, '_blank');
            } else {
                this.app.$q.notify('Ошибка создания сертификата');
            }
        });
    }
}
